import { Status, States } from '@sift/resift/models/Status';

import { PERSON_FETCH, PERSON_FETCH_SUCCESS, PERSON_FETCH_ERROR } from 'store/people';

// ------------------------------------
// Actions
// ------------------------------------
export const actions = {};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [PERSON_FETCH]: (state, action) => {
    return {
      ...state,
      status: new Status(States.LOADING),
    };
  },
  [PERSON_FETCH_SUCCESS]: (state, action) => {
    return {
      ...state,
      person: action.payload.data,
      status: new Status(States.NORMAL),
    };
  },
  [PERSON_FETCH_ERROR]: (state, action) => {
    return {
      ...state,
      status: new Status(States.ERROR),
    };
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = {
  person: {},
  status: new Status(),
};
export default function personReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}
